/**
 * HQ 직원 관리 서비스.
 */
import hqApi from './hqApiClient';

export interface HqStaff {
  id: string;
  email: string;
  name: string;
  role: 'hq_admin' | 'hq_staff';
  created_at?: string;
}

export interface HqStaffCreate {
  email: string;
  password: string;
  name: string;
  role: 'hq_admin' | 'hq_staff';
}

export const hqStaffService = {
  async list(): Promise<HqStaff[]> {
    const { data } = await hqApi.get<HqStaff[]>('/api/v1/hq/staff');
    return data;
  },

  async create(payload: HqStaffCreate): Promise<HqStaff> {
    const { data } = await hqApi.post<HqStaff>('/api/v1/hq/staff', payload);
    return data;
  },

  async delete(id: string): Promise<void> {
    await hqApi.delete(`/api/v1/hq/staff/${id}`);
  },
};
